import { render, staticRenderFns } from "./TeacherSettingLayout.vue?vue&type=template&id=36097bf8&scoped=true&lang=pug&"
import script from "./TeacherSettingLayout.vue?vue&type=script&lang=ts&"
export * from "./TeacherSettingLayout.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherSettingLayout.vue?vue&type=style&index=0&id=36097bf8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36097bf8",
  null
  
)

export default component.exports